import React, { useCallback } from 'react';
import { Button } from '../../components';
import { Row, Col, Tooltip } from 'antd';
import { DeleteOutlined, PlusOutlined, TagOutlined } from '@ant-design/icons';

export const Actions = React.memo(({ selectedRowKeys = [], onDelete, onAddTags, onAddCloudAccount }) => {
    // Filter out any group keys to get only actual appliance IDs
    const selectedApplianceIds = selectedRowKeys.filter((key) => !key.startsWith('group-'));
    const selectedCount = selectedApplianceIds.length;

    const handleDelete = useCallback(() => {
        if (selectedCount > 0 && onDelete) {
            onDelete(selectedApplianceIds);
        }
    }, [selectedApplianceIds, selectedCount, onDelete]);

    const handleAddTags = useCallback(() => {
        if (selectedCount > 0 && onAddTags) {
            onAddTags(selectedApplianceIds);
        }
    }, [selectedCount, selectedApplianceIds, onAddTags]);

    const handleAddCloudAccount = useCallback(() => {
        if (onAddCloudAccount) {
            onAddCloudAccount();
        }
    }, [onAddCloudAccount]);

    return (
        <>
            <Row gutter={[8, 8]}>
                {/* Add Migration Appliance Button */}
                <Col>
                    <Button
                        onClick={handleAddCloudAccount}
                        className="top-bar-acton-btn"
                        type="primary"
                        icon={<PlusOutlined />}
                    >
                        Add New Migration Appliance
                    </Button>
                </Col>
            </Row>
            <Row className={'margin-top-10'} gutter={[8, 8]} wrap={false} justify="middle">
                <Col>
                    <Tooltip
                        title={
                            selectedCount === 0
                                ? 'Select migration appliances to delete'
                                : `Delete ${selectedCount} selected appliance${selectedCount > 1 ? 's' : ''}`
                        }
                    >
                        <Button
                            icon={<DeleteOutlined />}
                            danger
                            disabled={selectedCount === 0}
                            onClick={handleDelete}
                            size="middle"
                        />
                    </Tooltip>
                </Col>
                <Col>
                    <Tooltip
                        title={
                            selectedCount === 0
                                ? 'Select migration appliances to add tags'
                                : `Add tags to ${selectedCount} selected appliance${selectedCount > 1 ? 's' : ''}`
                        }
                    >
                        <Button
                            icon={<TagOutlined />}
                            disabled={selectedCount === 0}
                            onClick={handleAddTags}
                            size="middle"
                            color="primary"
                            variant="outlined"
                        />
                    </Tooltip>
                </Col>
            </Row>
        </>
    );
});
